import { Button, Box, Typography } from "@mui/material";

interface Props {
  label: string;
  count: number;
  onChange: (delta: number) => void;
  disabled?: boolean;
}

export const DefectCounter = ({ label, count, onChange, disabled }: Props) => (
  <Box
    display="flex"
    alignItems="center"
    justifyContent="space-between"
    sx={{ maxWidth: 150, minWidth: 120 }}
  >
    <Box display="flex" alignItems="center" gap={1}>
      <Button
        variant="outlined"
        onClick={() => onChange(-1)}
        color="error"
        size="small"
        sx={{ minWidth: 36 }}
        disabled={disabled}
      >
        -
      </Button>
      <Typography data-testid={`${label.toLowerCase()}-counter`}>
        {count}
      </Typography>
      <Button
        variant="outlined"
        onClick={() => onChange(1)}
        color="error"
        size="small"
        disabled={disabled}
        sx={{ minWidth: 36 }}
      >
        +
      </Button>
    </Box>
  </Box>
);
